import { FormEvent, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Alert, Box, Button, Paper, Stack, TextField, Typography } from '@mui/material';
import { BrandMark } from '../components/BrandMark';
import { useAuth } from '../auth/AuthContext';
import { ApiError } from '../api/client';

export function Login() {
  const { login, sessionExpired, clearSessionExpired } = useAuth();
  const nav = useNavigate();
  const [loginId, setLoginId] = useState('');
  const [pw, setPw] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await login(loginId, pw);
      nav('/');
    } catch (e2) {
      setErr(e2 instanceof ApiError ? e2.message : '로그인 실패');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: '#0b1f3a' }}>
      <Paper sx={{ p: 5, width: 380 }}>
        <Stack alignItems="center" spacing={1} mb={3}>
          <BrandMark size={48} />
          <Typography variant="h2">디지털자산 검증 인프라</Typography>
          <Typography variant="body2" color="text.secondary">
            토큰증권 · 스테이블코인
          </Typography>
        </Stack>
        <form onSubmit={submit}>
          <Stack spacing={2}>
            {sessionExpired && !err && (
              <Alert severity="warning" onClose={clearSessionExpired}>
                로그인 세션이 만료되어 자동 로그아웃되었습니다. 다시 로그인해 주세요.
              </Alert>
            )}
            {err && <Alert severity="error">{err}</Alert>}
            <TextField label="아이디" value={loginId} onChange={(e) => setLoginId(e.target.value)} fullWidth autoFocus />
            <TextField label="비밀번호" type="password" value={pw} onChange={(e) => setPw(e.target.value)} fullWidth />
            <Button type="submit" variant="contained" size="large" disabled={busy}>
              {busy ? '로그인 중…' : '로그인'}
            </Button>
            <Typography variant="body2" align="center" color="text.secondary">
              계정이 없으신가요? <Link to="/signup">회원가입</Link>
            </Typography>
          </Stack>
        </form>
      </Paper>
    </Box>
  );
}
